// import axios from "axios"
// import { DEFAULT_VALUES_URL } from "../../constants"

// export const updateDefaultValues = async (userId, data) => {
//   return await axios.patch(`${DEFAULT_VALUES_URL}/${userId}`, data)
// }

import axiosPrivateMl from "@services/axiosPrivateMl";
import { ML_UPDATE_DEFAULT_VALUES_URL, ML_CREATE_DEFAULT_VALUES_URL } from "../../constants"

export const updateDefaultValues = async (userId, data, adAccountId=null) => {
   try {
      let url = `${ML_UPDATE_DEFAULT_VALUES_URL}/${userId}`
      if (adAccountId) {
        url = `${ML_UPDATE_DEFAULT_VALUES_URL}/${userId}?ad_account_id=${adAccountId}`
      }
      const response = await axiosPrivateMl.put(url, data)
      return response.data
   } catch (error) {
      console.log(error)
   }
}

export const createNewDefaultValues = async (userId, data, adAccountId) => {
   try {
      let url = `${ML_CREATE_DEFAULT_VALUES_URL}/${userId}`
      if (adAccountId) {
        url = `${ML_CREATE_DEFAULT_VALUES_URL}/${userId}?ad_account_id=${adAccountId}`
      }
      const response = await axiosPrivateMl.post(url, data)
      return response.data
   } catch (error) {
      console.log(error)
   }
}